import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled, { useTheme } from "styled-components";
import { routeList } from "../App";
import { lang } from "../assets/languages/en.language";
import Header from "../components/Header.component";
import Slider from "../components/Slider.component";
import GirlDesktop from "../components/svgs/illustrations/GirlDesktop";
import GirlDesktop2 from "../components/svgs/illustrations/GirlDesktop2";
import ManHamac from "../components/svgs/illustrations/ManHamac";
import { TertiaryButton } from "../styles/Button.style";
import { RootContainer } from "../styles/Container.style";
import { Column, Gap } from "../styles/Utils";

export default function FirstVisitPage() {
  const navigate = useNavigate();
  const theme = useTheme();

  useEffect(() => {
    // localStorage.clear();
    const isFirstVisit = localStorage.getItem("isFirstVisit");
    if (isFirstVisit) navigate(routeList.landing);
  });

  const endFirstVisit = () => {
    // mixpanel.track("End First Visit");
    localStorage.setItem("isFirstVisit", "exist");
    navigate(routeList.landing);
  };

  const cardPictures = [
    <GirlDesktop
      style={{
        // height: "120%",
        transform: "translateX(-20px) translateY(23%)",
      }}
    />,
    <GirlDesktop2
      style={{
        width: "120%",
        // height: "130%",
        transform: "translateX(-40px) translateY(46px)",
      }}
    />,
    <ManHamac
      style={{
        // height: "140%",
        transform: "translateX(0px) translateY(14%)",
      }}
    />,
  ];

  return (
    <RootContainer $background={theme.color.primary} $topSafe={true}>
      <Column $alignItem="center" $maxHeight>
        <Header sloganImgSrc="/slogans/slogan-red.png" />
        <Slider>
          {lang.firstVisitPage.cards.map((cardLabels, index) => (
            <Card key={cardLabels.key}>
              <CardDescription $fontSize={index == 0 ? "3.6dvh" : "3dvh"}>{cardLabels.description}</CardDescription>
              <IllustrationWrapper>{cardPictures[index]}</IllustrationWrapper>
            </Card>
          ))}
        </Slider>
        <Gap $height={2} />
        <TertiaryButton onClick={endFirstVisit}>
          <span>{lang.firstVisitPage.buttons.sign_up}</span>
        </TertiaryButton>
      </Column>
    </RootContainer>
  );
}

const IllustrationWrapper = styled.div`
  position: relative;
  height: 100%;
  svg {
    height: auto;
    width: 100%;
    position: absolute;
    bottom: 0px;
  }
`;

const CardDescription = styled.span<{ $fontSize?: string }>`
  line-height: 5dvh;
  z-index: 2;
  color: ${(props) => props.theme.color.primaryDark};
  font-family: ${(props) => props.theme.font.family.main};
  font-size: ${(props) => props.$fontSize ?? props.theme.font.size.title.big};
  text-shadow: ${(props) => props.theme.font.elevation.medium};
  text-align: center;
`;

const Card = styled(Column)`
  width: 80%;
  border-radius: 30px;
  padding: 2rem;
  background-color: ${(props) => props.theme.color.primaryLight};
  border: ${(props) => `2px solid ${props.theme.color.primaryDark}`};
  height: 55dvh;
`;
